export default __webpack_public_path__ + "static/media/FD1.df1d1fab.pdf";